<template>
  <div class="analytics">
    <h3 class="head">FOCUS TIME</h3>
    <div class="focus">
      <div class="today">
        <h4 class="head">TODAY</h4>
        <div class="amount">
          <span class="number">{{ doneToday }}</span>
          <span class="tomato">/TOMATO</span>
        </div>
      </div>
      <div class="week">
        <h4 class="head">WEEK</h4>
        <div class="amount">
          <span class="number">{{ doneWeek }}</span>
          <span class="tomato">/TOMATO</span>
        </div>
      </div>
    </div>
    <h3 class="head">
      <div>CHART</div>
      <div class="date">
        <button class="leftArrow" @click="changeFirstDate(-7)">
          &#60;
        </button>
        <span class="from">{{ dateString.from }}</span>
        -
        <span class="to">{{ dateString.to }}</span>
        <button class="rightArrow" @click="changeFirstDate(7)">
          >
        </button>
      </div>
    </h3>
    <div class="chart">
      <div class="container">
        <div class="left">
          <div class="amount" v-for="i in 6" :key="i">{{ (7 - i) * 4 }}</div>
        </div>
        <div class="graph">
          <div class="bar" v-for="i in 7" :key="i">
            <div
              class="barAmount"
              :class="{
                today:
                  tomatoRecord[dateString.weekKey] !== undefined &&
                  tomatoRecord[dateString.weekKey].dates[i - 1] ===
                    today.getTime()
              }"
              :style="computeHeight(i)"
            ></div>
          </div>
        </div>
      </div>

      <div class="bottom">
        <div class="date" v-for="i in 7" :key="i">
          {{ dateString.dates[i - 1] }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Analytics",
  data() {
    return {
      firstDate: new Date(this.$store.state.thisWeek.getTime()),
      today: this.$store.state.today,
      dateString: {
        to: null,
        from: null,
        dates: [],
        weekKey: ""
      }
    };
  },
  computed: {
    tomatoRecord() {
      return this.$store.state.tomatoRecord;
    },
    thisWeek() {
      return this.$store.state.thisWeek;
    },
    list() {
      return this.$store.state.list;
    },
    doneTaskList() {
      let result = [];
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].done === true) {
          result.push(this.list.slice(i, i + 1)[0]);
        }
      }
      return result;
    },
    doneToday() {
      let amount = 0;
      for (let i = 0; i < this.doneTaskList.length; i++) {
        amount += this.doneTaskList[i].tomatoAmount;
      }
      return amount;
    },
    doneWeek() {
      let weekKey = `${this.thisWeek.getFullYear()}/${this.thisWeek.getMonth() +
        1}/${this.thisWeek.getDate()}`;
      if (this.tomatoRecord[weekKey]) {
        let amount = 0;
        for (let i = 0; i < 7; i++) {
          amount += this.tomatoRecord[weekKey].tomatoAmount[i];
        }
        return amount;
      } else {
        return this.doneToday;
      }
    }
  },
  methods: {
    changeFirstDate: function(day) {
      this.firstDate.setDate(this.firstDate.getDate() + day);
      this.generateDateString();
    },
    generateDateString: function() {
      this.dateString.dates = [];
      for (let i = 0; i < 7; i++) {
        let date = new Date(this.firstDate.getTime());
        date.setDate(date.getDate() + i);
        if (i == 0) {
          this.dateString.from = `${date.getFullYear()}.${date.getMonth() +
            1}.${date.getDate()}`;
        } else if (i == 6) {
          this.dateString.to = `${date.getFullYear()}.${date.getMonth() +
            1}.${date.getDate()}`;
        }
        this.dateString.dates.push(`${date.getMonth() + 1}/${date.getDate()}`);
      }
      this.dateString.weekKey = `${this.firstDate.getFullYear()}/${this.firstDate.getMonth() +
        1}/${this.firstDate.getDate()}`;
    },
    computeHeight: function(i) {
      if (
        this.tomatoRecord[this.dateString.weekKey] !== undefined &&
        this.tomatoRecord[this.dateString.weekKey].dates[i - 1] ===
          this.today.getTime()
      ) {
        return `height:${(this.doneToday / 24) * 100}%;`;
      } else {
        return `height:${
          this.tomatoRecord[this.dateString.weekKey] === undefined
            ? 0
            : (this.tomatoRecord[this.dateString.weekKey].tomatoAmount[i - 1] /
                24) *
              100
        }%`;
      }
    }
  },
  mounted() {
    this.generateDateString();
  },
  created() {
    this.$store.dispatch("updateTomatoRecord", { type: "filing" });
  }
};
</script>

<style lang="scss" scoped>
$working: #ff4384;
$break: #00a7ff;
$setting: #003164;
.analytics {
  width: 765px;
  padding-left: 125px;
}

.analytics .head,
.ringtones .head {
  color: #fff;
  background-color: #335a83;
  width: 445px;
  height: 44px;
  border: 0;
  padding: 0px 16px;
  margin-top: 48px;
  line-height: 44px;
  font-size: 24px;
  display: flex;
  justify-content: space-between;
}

.analytics .head .date {
  font-size: 16px;
}

.analytics .head .leftArrow,
.analytics .head .rightArrow {
  background-color: transparent;
  border: 0;
  color: #fff;
  font-family: "Consolas";
  padding: 8px;
  font-weight: bold;
  font-size: 16px;
}

.analytics .head .from,
.analytics .head .to {
  padding: 8px;
}

.analytics .focus {
  width: 445px;
  display: flex;
  justify-content: space-between;
}

.analytics .focus .head {
  margin: 0;
  padding: 0;
  background-color: transparent;
  font-size: 16px;
}

.analytics .focus .today {
  width: 35%;
}

.analytics .focus .week {
  width: 42.9213%;
}

.analytics .focus .amount .number {
  font-size: 64px;
  color: $working;
  padding: 4px 0px 7px 0px;
}

.break .analytics .focus .amount .number {
  color: $break;
}

.analytics .focus .amount .tomato {
  font-size: 16px;
  color: #335a83;
  margin-left: 8px;
}

.analytics .chart {
  color: #fff;
  height: initial;
}

.analytics .chart .container {
  display: flex;
  justify-content: flex-start;
  height: initial;
  margin-top: 16px;
  align-items: flex-end;
}

.analytics .chart .left {
  width: 25px;
  font-size: 16px;
  height: 240px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin-bottom: 9px;
}

.analytics .chart .left .amount {
  margin-bottom: 20px;
  height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.analytics .chart .graph {
  width: 419px;
  height: 232px;
  border: #fff solid 1px;
  border-top: 0;
  border-right: 0;
  display: flex;
  justify-content: space-evenly;
  align-items: flex-end;
}

.analytics .chart .bar {
  width: 30px;
  height: 228px;
  display: flex;
  align-items: flex-end;
}

.analytics .chart .bar .barAmount {
  box-sizing: initial;
  background-color: #fff;
  width: 100px;
  &.today {
    background-color: $working;
  }
}

.break .analytics .chart .bar .barAmount.today {
  background-color: $break;
}

.analytics .chart .bottom {
  width: 419px;
  margin: 16.5px 0 0 25px;
  display: flex;
  justify-content: space-evenly;
}

.analytics .chart .bottom .date {
  width: 30px;
  text-align: center;
  display: flex;
  justify-content: center;
}
</style>
